import { Observable } from 'rxjs';

/**
 * @module PaymentProcessorService
 */
function createPaymentProcessorService(apiService) {
    const _paymentProcessorService = {};
    let data;

    /**
     * @returns {Observable} payment processor data
     * @name get
     * @method
     */
    _paymentProcessorService.get = function(id) {
        return new Observable(subscriber => {
            if (!data) {
                apiService.services.getPaymentProcessor({ paymentProcessorId: id }).then(
                    processorResponse => {
                        data = processorResponse.data;
                        subscriber.next(data);
                        subscriber.complete();
                    },
                    e => subscriber.error(e)
                );
            } else {
                subscriber.next(data);
                subscriber.complete();
            }
        });
    };

    return Object.freeze(_paymentProcessorService);
}

export default createPaymentProcessorService;
